import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: 'auto',
        },
        container: {
            [theme.breakpoints.down('xs')]: {
                paddingLeft: theme.spacing(0),
                paddingRieght: theme.spacing(0),

                padding: theme.spacing(0),
            },
        },
        steps: {
            fontWeight: 400,
            fontSize: theme.spacing(1),
        },
        button: {
            marginTop: theme.spacing(5),
            marginLeft: 0,
            borderRadius: 20,
            width: 240,
            justifyContent: 'space-between',
            height: 40,
            fontWeight: 700,
            fontStyle: 'normal',
            fontSize: theme.spacing(1.5),
            letterSpacing: '0.8px',
        },
        input: {
            fontSize: theme.spacing(1),
            '& .MuiInput-underline:after': {
                borderColor: '#D5D8DF',
            },
            '& .MuiInput-underline:before': {
                borderColor: '#D5D8DF',
            },
        },
    }),
);
